import { createFileRoute } from "@tanstack/react-router";
import AISpacedRepetitionGuideFr from "@/pages/resources/fr/AISpacedRepetitionGuideFr";

export const Route = createFileRoute("/fr/learn/ai-spaced-repetition")({
  head: () => ({
    meta: [
        {
            "title": "Répétition espacée avec l'IA : comment ça marche | System Atlas"
        },
        {
            "name": "description",
            "content": "Comment l'IA améliore la répétition espacée avec planification automatique (SM-2), quiz adaptatifs et analyse des lacunes. Guide complet pour la rétention à long terme."
        },
        {
            "property": "og:title",
            "content": "Répétition espacée avec l'IA : comment ça marche | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Comment l'IA améliore la répétition espacée avec planification automatique (SM-2), quiz adaptatifs et analyse des lacunes. Guide complet pour la rétention à long terme."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/ai-spaced-repetition"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Répétition espacée avec l'IA : comment ça marche | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Comment l'IA améliore la répétition espacée avec planification automatique (SM-2), quiz adaptatifs et analyse des lacunes. Guide complet pour la rétention à long terme."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/ai-spaced-repetition"
        }
    ],
  }),
  component: AISpacedRepetitionGuideFr,
});
